import { useState } from "react";
import { useDispatch } from "react-redux";
import "primeflex/primeflex.css";
import Services from "../service/ApiServices"
import { ErrorToast } from "../redux/actions/ToasterAction";
import _ from 'lodash'


export const useClientService = ()=>{
    const [filteredClient, setFilteredClient] = useState([]);  
  

    const SearchClient = (event)=>{setTimeout(async () => {
        let _filteredClient;
        if (!event.query.trim().length) {
            _filteredClient = [];
        }
        else {            
            _filteredClient = (await Services.Census.getClients(event.query.toLowerCase())).data            
        }
        setFilteredClient(_filteredClient);
    }, 250)};

    const dispatchClient = useDispatch();
    const GetClientDetails = async (assignmentId)=>{
        try{
            const data =  (await Services.Census.getClientDetails(assignmentId)).data  
            return data;
        }
        catch(err){
            dispatchClient(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     

    }

    const GetClientBedHistory = async (clientId)=>{
        try{
            return  (await Services.Census.getClientBedHistory(clientId)).data
        }
        catch(err){
            dispatchClient(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }     
    }

    const GetClientAllergyDetails = async (clientId)=>{
        try{
            return (await Services.Census.getClientAllergy(clientId)).data   
        }
        catch(err){
            dispatchClient(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }         
    }

    const GetClientMedicationDetails = async (clientId)=>{
        try{
            return (await Services.Census.getClientMedication(clientId)).data   
        }
        catch(err){
            dispatchClient(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }        
    }

    return   {filteredClient, SearchClient, GetClientDetails, GetClientBedHistory, GetClientAllergyDetails, GetClientMedicationDetails}
}


